import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { billingGroupsKeys } from '../../api/query-keys/billing-groups';

import { hostsKeys } from '@/features/hosts/api/query-keys/hosts';

export const useRemoveHostFromBillingGroup = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ hostId, billingGroupId }: { hostId: number; billingGroupId: number }) =>
      billingGroupApi.removeHostFromBillingGroup(billingGroupId, hostId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: hostsKeys.all,
      });
      queryClient.invalidateQueries({
        queryKey: billingGroupsKeys.all,
      });

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
